import PropTypes from "prop-types";
import { Grid } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import IconButton from "@mui/material/IconButton";
import { colorTextMuted, colorSurfaceHover, colorSurface } from "src/design/tokens";
import { RestaurantAutocomplete } from "src/components/Main/MainLayout/RestaurantAutocomplete";

const Header = ({
  handleDrawerOpen,
  leftDrawerOpened,
  closedDrawer,
  Restaurant_list,
}) => {
  return (
    <Grid container width="100%" alignItems="center">
      {!leftDrawerOpened && !closedDrawer && (
        <Grid item md={1}>
          <IconButton
            style={{ borderRadius: 16, height: 35, alignSelf: "center" }}
            sx={{ color: colorTextMuted, ":hover": { bgcolor: colorSurfaceHover }, mr: 2 }}
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
          >
            <MenuIcon />
          </IconButton>
        </Grid>
      )}
      {!leftDrawerOpened && (
        <Grid item xs={8}>
          <RestaurantAutocomplete
            restaurants={Restaurant_list}
            handleHomeEndKeys
            inputRootStyles={{ backgroundColor: colorSurface }}
          />
        </Grid>
      )}
    </Grid>
  );
};

Header.propTypes = {
  handleDrawerOpen: PropTypes.func,
};

export default Header;
